import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const rychla6Config: LotteryConfigModel = {
    lottery: Lottery.rychla6,
    boardCount: 3,
    primaryBoardSize: 6,
    defaultStake: 10,
    defaultStakeKasa: 1000,
    primaryNumbers: 26,

    boardLabel: "",
    hasDurationComponent: false,
    hasDrawOptions: false,
    hasMultidrawNotification: false,
    hasAllOrOneMultidrawOptions: false,
    hasSubscription: false,
    isDrawnEveryDay: true,
    durationTitle: "",
    durationTitleShort: "Rychlá 6 se losuje co 5 minut.",
    maxDuration: 12,
    multidrawDurationOptions: [],
    durationOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    stakeOptions: [10, 20, 30, 40, 50, 100, 200, 500],
};
